<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconTicket">
      <path
        id="Vector"
        d="M9.5 11H2.5C1.1215 11 0 9.8785 0 8.5V8.039C0 7.763 0.224 7.539 0.5 7.539C0.512 7.539 0.5265 7.5395 0.541 7.5405C1.094 7.53 1.541 7.0765 1.541 6.5205C1.541 5.9645 1.094 5.5105 0.541 5.5C0.5265 5.501 0.512 5.5015 0.5005 5.5015C0.2245 5.5015 0.0005 5.2775 0.0005 5.0015V4.4995C0 3.1215 1.1215 2 2.5 2H9.5C10.8785 2 12 3.1215 12 4.5V5C12 5.276 11.776 5.5 11.5 5.5C10.9485 5.5 10.5 5.9485 10.5 6.5C10.5 7.0515 10.9485 7.5 11.5 7.5C11.776 7.5 12 7.724 12 8V8.5C12 9.8785 10.8785 11 9.5 11ZM1 8.4835V8.5C1 9.327 1.673 10 2.5 10H9.5C10.327 10 11 9.327 11 8.5V8.437C10.1385 8.2145 9.5 7.4305 9.5 6.5C9.5 5.5695 10.1385 4.786 11 4.563V4.5C11 3.673 10.327 3 9.5 3H2.5C1.673 3 1 3.673 1 4.5V4.5575C1.8835 4.7735 2.541 5.5715 2.541 6.5205C2.541 7.4695 1.8835 8.2675 1 8.4835Z"
        fill="white"
      />
    </g>
  </svg>
</template>
